// extracted by mini-css-extract-plugin
module.exports = {"primary":"#beaf87"};